import dayjs from 'dayjs';
import * as Joi from 'joi';

const jobStatusReportSchema = Joi.object({
  jobKey: Joi.string().required().messages({
    'any.required': 'Please select job name',
  }),
  dates: Joi.object({
    startDate: Joi.string().required().messages({
      'string.required': 'Start Date not allowed to be empty.',
      'any.required': 'Start Date not allowed to be empty.',
      'date.max': 'Start Date should not be greater than current date.',
    }),
    endDate: Joi.string().required().custom((values, helpers) => {
      const { startDate, endDate } = values;
      if (dayjs(endDate).isBefore(dayjs(startDate))) {
        return helpers.error('date.min');
      }
      return values;
    }).messages({
      'string.required': 'End Date not allowed to be empty.',
      'any.required': 'End Date not allowed to be empty.',
      'date.min': 'End Date should be greater than Start Date.',
      'date.max': 'End Date should not be greater than current date.',
    }),
  })
    .custom((values, helpers) => {
      const { startDate, endDate } = values;
      if (dayjs(endDate).diff(startDate, 'month', true) > parseFloat('3.0')) {
        return helpers.error('date.range');
      }
      return values;
    })
    .messages({
      'date.range': 'Search range should not be more than 3 months',
    }),
});

export default jobStatusReportSchema;
